export const ownerTypes = [
    {value: '1', name: 'Federal'},
    {value: '2', name: 'State'},
    {value: '3', name: 'County'},
    {value: '4', name: 'City'},
    {value: '5', name: 'Town'},
    {value: '6', name: 'Village'},
    {value: '7', name: 'Mixed Government'},
    {value: '8', name: 'Private'},
    {value: '9', name: 'Public School District or BOCES'},
    {value: '10', name: 'Road Right of Way'},
    {value: '-999', name: 'Unknown'}
];

export const propTypes = [
    {value: '100', name: 'Agricultural'},
    {value: '105', name: 'Agricultural Vacant Land (Productive)'},
    {value: '110', name: 'Livestock and Products'},
    {value: '111', name: 'Poultry and Poultry Products: eggs, chickens, turkeys, ducks and geese'},
    {value: '112', name: 'Dairy Products : Milk, butter and cheese'},
    {value: '113', name: 'Cattle, Calves and hogs'},
    {value: '114', name: 'Sheep and wool'},
    {value: '115', name: 'Honey and Beeswax'},
    {value: '116', name: 'Other livestock : Donkeys and goats'},
    {value: '117', name: 'Horse Farms'},
    {value: '120', name: 'Field Crops'},
    {value: '129', name: 'Acquired Development Rights'},
    {value: '130', name: 'Truck Crops - Mucklands'},
    {value: '140', name: 'Truck crops - Not mucklands'},
    {value: '150', name: 'Orchard crops'},
    {value: '151', name: 'Apples,Pears,Peaches,Cherries,etc'},
    {value: '152', name: 'Vineyards'},
    {value: '160', name: 'Other fruits'},
    {value: '170', name: 'Nursery and greenhouse'},
    {value: '180', name: 'Speciality farms'},
    {value: '181', name: 'Fur Products:mink,chinchilla,etc'},
    {value: '182', name: 'Pheasant etc'},
    {value: '183', name: 'Aquatic: oysterlands,fish and aquatic plants'},
    {value: '184', name: 'Livestock: deer,moose,llamas,buffalo,etc'},
    {value: '190', name: 'Fish,game and wildlife preserves'},
    {value: '200', name: 'Residential'},
    {value: '210', name: 'One family year-round Residential'},
    {value: '215', name: 'One family year-round Residential with accessory apartment'},
    {value: '220', name: 'Two family year around Residential'},
    {value: '230', name: 'Three family year around Residential'},
    {value: '240', name: 'Rural Residential with Acreage'},
    {value: '241', name: 'Primary Residential,also used in agricultural production'},
    {value: '242', name: 'Recreational use'},
    {value: '250', name: 'Estate'},
    {value: '260', name: 'Seasonal Residentials'},
    {value: '270', name: 'Mobile home'},
    {value: '271', name: 'Multiple mobile homes'},
    {value: '280', name: 'Residential - Multi-Purpose/Multi-Structure'},
    {value: '281', name: 'Multiple Residentials'},
    {value: '283', name: 'Residential with Incidental commercial use'},
    {value: '300', name: 'Vacant land'},
    {value: '310', name: 'Residential'},
    {value: '311', name: 'Residential Vacant land'},
    {value: '312', name: 'Residential land including a small improvement(not used for living accommodation)'},
    {value: '314', name: 'Rural Vacant lots of 10 acres or less'},
    {value: '315', name: 'Underwater vacant land'},
    {value: '320', name: 'rural'},
    {value: '321', name: 'Abandoned Agricultural land'},
    {value: '322', name: 'Residential vacant land over 10 acres'},
    {value: '323', name: 'Other rural vacant lands'},
    {value: '330', name: 'Vacant land located in commercial areas'},
    {value: '331', name: 'Commercial vacant land with minor improvements'},
    {value: '340', name: 'Vacant land located in Industrial areas'},
    {value: '341', name: 'Industrial vacant land with minor improvements'},
    {value: '350', name: 'Urban renewal or slum clearance'},
    {value: '351', name: 'Shell building - resvalueential'},
    {value: '352', name: 'Shell building - commercial'},
    {value: '380', name: 'Public utility vacant land'},
    {value: '400', name: 'Commercial'},
    {value: '410', name: 'Living accommodations'},
    {value: '411', name: 'Apartments'},
    {value: '414', name: 'Hotel'},
    {value: '415', name: 'Motel'},
    {value: '416', name: 'Mobile home parks(trailer parks,trailer courts)'},
    {value: '417', name: 'Camps,cottages and bungalows'},
    {value: '418', name: 'Inns,lodges,Boarding and rooming houses, Tourist homes, Fraternity and Sorority houses'},
    {value: '420', name: 'Dining Establishments'},
    {value: '421', name: 'Restaurants'},
    {value: '422', name: 'Diners and luncheonettes'},
    {value: '423', name: 'Snack bars,Drive-ins,ice cream bars'},
    {value: '424', name: 'Night clubs'},
    {value: '425', name: 'bar'},
    {value: '426', name: 'Fast food franchises'},
    {value: '430', name: 'Motor Vehicle Services'},
    {value: '431', name: 'Auto dealers-Sales and service'},
    {value: '432', name: 'Service and Gas stations'},
    {value: '433', name: 'Auto body,Tire shops,Other related auto sales'},
    {value: '434', name: 'Automatic car wash'},
    {value: '435', name: 'Manual Car wash'},
    {value: '436', name: 'Self-service car wash'},
    {value: '437', name: 'Parking garage'},
    {value: '438', name: 'Parking lot'},
    {value: '439', name: 'Small parking garage'},
    {value: '440', name: 'Storage, warehouse and Distribution facilities'},
    {value: '441', name: 'Fuel Storage and distribution facilities'},
    {value: '442', name: 'Mini warehouse(self storage'},
    {value: '443', name: 'Grain and feed elevators,Mixers,Sales outlets'},
    {value: '444', name: 'Lumber yards , Sawmills'},
    {value: '445', name: 'Coal yards,Bins'},
    {value: '446', name: 'Cold storage facilities'},
    {value: '447', name: 'Trucking terminals'},
    {value: '448', name: 'Piers,Wharves,Docks and Related facilities'},
    {value: '449', name: 'Other storage, warehouse and distribution facilities'},
    {value: '450', name: 'Retail Services'},
    {value: '451', name: 'Regional Shopping centers'},
    {value: '452', name: 'Area or neighborhood shopping centres'},
    {value: '453', name: 'Large retail outlets'},
    {value: '454', name: 'Large retail food stores'},
    {value: '455', name: 'Dealerships-Sales and Service(other than auto with large sales operation'},
    {value: '460', name: 'Banks and Office buildings'},
    {value: '461', name: 'Standard Bank/Single occupant'},
    {value: '462', name: 'Drive-in branch bank'},
    {value: '463', name: 'Bank complex with office building'},
    {value: '464', name: 'office building'},
    {value: '465', name: 'Professional building'},
    {value: '470', name: 'Miscellaneous services'},
    {value: '471', name: 'Funeral homes'},
    {value: '472', name: 'Dog kennels,Veterinary clinics'},
    {value: '473', name: 'Greenhouses'},
    {value: '474', name: 'Billboards'},
    {value: '475', name: 'Junkyards'},
    {value: '480', name: 'Multiple use or Multi-purpose'},
    {value: '481', name: 'Downtown row Type(with common wall)'},
    {value: '482', name: 'Downtown row type(detached)'},
    {value: '483', name: 'converted resvalueence'},
    {value: '484', name: 'One story small structure'},
    {value: '485', name: 'One story small structure-Multi occupant'},
    {value: '486', name: 'Minimart'},
    {value: '500', name: 'Recreation and Entertainment'},
    {value: '510', name: 'Entertainment Assembly'},
    {value: '511', name: 'Legitimate theaters'},
    {value: '512', name: 'Motion pictures theatres(excludes drive-in theatres'},
    {value: '513', name: 'Drive-in theatres'},
    {value: '514', name: 'Auditoriums,exhibition and Exposition halls'},
    {value: '515', name: 'Radio,T.V and Motion picture studios'},
    {value: '520', name: 'Sports assembly'},
    {value: '521', name: 'Stadiums,arenas,armories,Field houses'},
    {value: '522', name: 'Racetracks'},
    {value: '530', name: 'Amusement Facilities'},
    {value: '531', name: "Fairgrounds"},
    {value: '532', name: 'Amusement parks'},
    {value: '533', name: 'Game farms'},
    {value: '534', name: 'Social organizations'},
    {value: '540', name: 'Indoor sports facilities'},
    {value: '541', name: 'Bowling centers'},
    {value: '542', name: 'Ice or roller skater rinks'},
    {value: '543', name: 'YMCAs,YWCAs,etc'},
    {value: '544', name: 'Health spas'},
    {value: '545', name: 'Indoor swimming pools'},
    {value: '546', name: 'other Indoor sports'},
    {value: '550', name: 'Outdoor Sports activities'},
    {value: '551', name: 'Skiing centers'},
    {value: '552', name: 'Public golf courses'},
    {value: '553', name: 'Private Golf Country clubs'},
    {value: '554', name: 'Outdoor swimming pools'},
    {value: '555', name: 'Rvalueing stables'},
    {value: '557', name: 'Other outdoor sports'},
    {value: '560', name: 'Improved Beaches'},
    {value: '570', name: 'Marinas'},
    {value: '580', name: 'Camps,Camping Facilities and resorts'},
    {value: '581', name: 'camps'},
    {value: '582', name: 'Camping Facilities'},
    {value: '583', name: 'Resort complexes'},
    {value: '590', name: 'Parks'},
    {value: '591', name: 'playgrounds'},
    {value: '592', name: 'Athletic fields'},
    {value: '593', name: 'Picnic grounds'},
    {value: '600', name: 'Community Services'},
    {value: '610', name: 'Education'},
    {value: '611', name: 'Libraries'},
    {value: '612', name: 'Schools'},
    {value: '613', name: 'Colleges and Universities'},
    {value: '614', name: 'Special schools and institutions'},
    {value: '615', name: 'Other Educational facilities'},
    {value: '620', name: 'Religious'},
    {value: '630', name: 'Welfare'},
    {value: '631', name: 'Orphanage'},
    {value: '632', name: 'Benevolent and moral associations'},
    {value: '633', name: 'Home for the aged'},
    {value: '640', name: 'Health'},
    {value: '641', name: 'Hospitals'},
    {value: '642', name: 'All other health facilities'},
    {value: '650', name: 'Government'},
    {value: '651', name: 'Highway garage'},
    {value: '652', name: 'Office building'},
    {value: '653', name: 'Parking lots'},
    {value: '660', name: 'Protection'},
    {value: '661', name: 'Army,Navy,Air force, Marine and Coast Guard'},
    {value: '662', name: 'Police and fire protection,Electrical Signal'},
    {value: '670', name: 'Correctional'},
    {value: '680', name: 'Cultural and Recreational'},
    {value: '681', name: 'Cultural facilities'},
    {value: '682', name: 'Recreational facilities'},
    {value: '690', name: 'Miscellaneous'},
    {value: '691', name: 'Professional Associations'},
    {
        value: '692',
        name: 'Roads,Streets,Highways and parkways, Express or otherwise(if included) including adjoining land'
    },
    {value: '693', name: 'Indian Reservations'},
    {value: '694', name: 'Animal Welfare Shelters'},
    {value: '695', name: 'Cemeteries'},
    {value: '700', name: 'Industrial'},
    {value: '710', name: 'Manufacturing and Processing'},
    {value: '712', name: 'High tech. manufacturing and processing'},
    {value: '714', name: 'Light industrial manufacturing and processing'},
    {value: '715', name: 'Heavy Manufacturing and Processing'},
    {value: '720', name: 'Mining and Quarrying'},
    {value: '730', name: 'Wells'},
    {value: '731', name: 'Oil-Natural Flow(for production)'},
    {value: '732', name: 'Oil- Forced Flow(for production)'},
    {value: '733', name: 'Gas(for production)'},
    {value: '734', name: 'Junk'},
    {value: '735', name: 'Water used for oil production'},
    {value: '736', name: 'Gas or oil storage wells'},
    {value: '740', name: 'Industrial Product pipelines'},
    {value: '741', name: 'Gas'},
    {value: '742', name: 'Water'},
    {value: '743', name: 'Brine'},
    {value: '744', name: 'Petroleum products'},
    {value: '749', name: 'other'},
    {value: '800', name: 'Public services'},
    {value: '820', name: 'Water'},
    {value: '821', name: 'Flood control'},
    {value: '822', name: 'Water Supply'},
    {value: '823', name: 'Water treatment facilities'},
    {value: '826', name: 'Water transmission improvements'},
    {value: '827', name: 'Water transmission outsvaluee plant'},
    {value: '830', name: 'Communication'},
    {value: '831', name: 'Telephone'},
    {value: '832', name: 'Telegraph'},
    {value: '833', name: 'Radio'},
    {value: '834', name: 'Television other than Community Antenna television'},
    {value: '835', name: 'Community Antenna Television'},
    {value: '836', name: 'Telephone outsvaluee plant'},
    {value: '837', name: 'Cellular telephone towers'},
    {value: '840', name: 'Transportation'},
    {value: '841', name: 'Motor Vehicle'},
    {value: '842', name: 'Ceiling railroad'},
    {value: '843', name: 'Non ceiling railroad'},
    {value: '844', name: 'Air'},
    {value: '845', name: 'Water'},
    {value: '846', name: 'Brvalueges,tunnels and subways'},
    {value: '847', name: 'Pipelines'},
    {value: '850', name: 'Waste Disposal'},
    {value: '851', name: 'Solvalue waste'},
    {value: '852', name: 'Landfill and dumps'},
    {value: '853', name: 'Sewage treatment and water pollution control'},
    {value: '854', name: 'Air pollution control'},
    {value: '860', name: 'Special Franchise property'},
    {value: '861', name: 'Electric and gas'},
    {value: '862', name: 'Water'},
    {value: '866', name: 'Telephone'},
    {value: '867', name: 'Miscellaneous'},
    {value: '868', name: 'Pipelines'},
    {value: '869', name: 'Television'},
    {value: '870', name: 'Electric and Gas'},
    {value: '871', name: 'Electric and Gas facilities'},
    {value: '872', name: 'Electric sub station Electric power generation facilities'},
    {value: '873', name: 'Gas measuring and regulation station'},
    {value: '874', name: 'Electric Power generation Facility - Hydro'},
    {value: '875', name: 'Electric Power generation Facility - Fossil Fuel'},
    {value: '876', name: 'Electric Power generation Facility - Nuclear'},
    {value: '877', name: 'Electric Power generation Facility - Other fuel'},
    {value: '880', name: 'Electric and Gas Transmission and distribution'},
    {value: '882', name: 'Electric transmission improvement'},
    {value: '883', name: 'Gas transmission improvement'},
    {value: '884', name: 'Electric distribution-Outsvaluee plant property'},
    {value: '885', name: 'Gas distribution - Outsvaluee plant property'},
    {value: '900', name: 'Wild Forested Conservation lands and public parks'},
    {value: '910', name: 'Private Wild and Forest Lands except for Private Hunting and Fishing Clubs'},
    {value: '911', name: 'Forest Land Under Section 480 of the Real Property Tax Law'},
    {value: '912', name: 'Forest Land Under Section 480-a of the Real Property Tax Law'},
    {value: '920', name: 'Private Hunting and Fishing Clubs'},
    {value: '930', name: 'State Owned Forest Lands'},
    {
        value: '931',
        name: 'State Owned Land (Forest Preserve) in the Adirondack or Catskill Parks Taxable Under Section 532-a of the Real Property Tax Law'
    },
    {
        value: '932',
        name: 'State Owned Land Other Than Forest Preserve Covered Under Section 532-b, c, d, e, f, or g of the Real Property Tax Law'
    },
    {value: '940', name: 'Reforested Land and Other Related Conservation Purposes'},
    {value: '941', name: 'State Owned Reforested Land Taxable Under Sections 534 and 536 of the Real Property Tax Law'},
    {value: '942', name: 'County Owned Reforested Land'},
    {value: '950', name: 'Hudson River and Black River Regulating District Land'},
    {value: '960', name: 'Public Parks'},
    {value: '961', name: 'State Owned Public Parks, Recreation Areas, and Other Multiple Uses'},
    {value: '962', name: 'County Owned Public Parks and Recreation Areas'},
    {value: '963', name: 'City/Town/Village Public Parks and Recreation Areas'},
    {value: '970', name: 'Other Wild or Conservation Lands'},
    {
        value: '971',
        name: 'Wetlands, Either Privately or Governmentally Owned, Subject to Specific Restrictions as to Use'
    },
    {
        value: '972',
        name: 'Land Under Water, Either Privately or Governmentally Owned (other than resvalueential - more properly classified as value 315)'
    },
    {value: '980', name: 'Taxable State Owned Conservation Easements'},
    {value: '990', name: 'Other Taxable State Land Assessments'},
    {value: '991', name: 'Adirondack Park Aggregate Additional Assessments (Real Property Tax Law, Section 542(3))'},
    {
        value: '992',
        name: 'Hudson River-Black River Regulating District Aggregate Additional Assessments (Environmental Conservation Law, Section 15-2115)'
    },
    {value: '993', name: 'Transition Assessments for Taxable State Owned Land (Real Property Tax Law, Section 545)'},
    {value: '994', name: 'Transition Assessments for Exempt State Owned Land (Real Property Tax Law, Section 545)'}
];

export default {
    'Owner Type': ownerTypes,
    'Land Use Type': propTypes,
    getName: (obj = [], val) => (obj.find(o => o.value === val) || {}).name,
    getValue: (obj = [], name) => (obj.find(o => o.name === name) || {}).value,
    getNames: (obj = []) => obj.map(o => o.name),
    getValues: (obj = []) => obj.map(o => o.value),

}